export default class Chat {
	constructor({members, messages, admin, name, key}) {
		this.members = members || [];
		this.messages = messages || {};
		this.admin = admin || null;
		this.name = name || null;
		if (key) {
			this.key = key;
		}
	}
}
